import * as Backbone from 'Backbone';
import _ from 'underscore';
import { CWTypoStandardModel } from './cwTypoStandard.model';

/**
 * Parametres TypoStandard Collection
 */
export class CWTypoStandardColl extends Backbone.Collection {


  /**
   * habilitationV
   */
  habilitationV: string;
  /**
   * habilitationG
   */
  habilitationG: string;
  /**
   * usecase
   */
  usecase: string;


  constructor(models?: CWTypoStandardModel[] | { [key: string]: any }[], options?: { [key: string]: any }) {
    if (!options && !_.isEmpty(models)) {
      options = models;
    }
    options = options || {};
    options.model = options.model || CWTypoStandardModel;
    super(models, options);
    this.usecase = options.usecase || "app";
    this.habilitationV = "N";
    this.habilitationG = "N";
    this.url = (): string => {
      return Configuration.restRoot + "/rest/activite/typodom/standard";
    }
  }

  /**
   * Get a Typologye by code
   */
  get(id: string | number): any {
    const element = Backbone.Collection.prototype.get.call(this, id);
    let result = element;

    if (element instanceof Backbone.Model) {
      result = element.clone();
    }
    return result;
  }
}
